<template>
  <div class='footer'>
    <span>© {{year}} VUILD</span>
    <a v-bind:href='baseUrl + "static/documents/EMARF_TOS_V200.pdf"' target='_blank'>Terms of service / 利用規約</a>
  </div>
</template>

<script>

export default {
  props: {
    baseUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return{
      year: new Date().getFullYear()
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/viewer/Footer.vue